<template>
  <thead>
  <tr>
    <td><slot></slot></td>
    <th v-for="(year, i) in years" :key="'header-' + i" :class="{ 'text-left': align === 'left', 'text-center': align === 'center', 'text-right': align === 'right' }">{{ year }}</th>
  </tr>
  </thead>
</template>

<script>

export default {
  name: 'operative-table-header',
  props: {
    years: {
      type: Array,
      default: () => [],
    },
    align: {
      type: String,
      default: 'default',
    },
  },
};

</script>

<style lang="scss">

thead tr td {
  text-transform: uppercase;
}

thead tr th {
  text-align: right;
  text-transform: uppercase;
}

</style>
